import { GuideImg } from "@/components/guides/GuideBody";
import { GUIDE_IMAGES } from "@/content/guides/images";
import { getMedia } from "@/content/media";

/** A content image (src/content/media) on a page: AVIF / WebP / JPEG with srcset, width and height, lazy unless
 *  `eager`. The alt defaults to the image's own description. */
const ContentImage = ({ name, alt, eager, sizes, className }: { name: string; alt?: string; eager?: boolean; sizes?: string; className?: string }) => {
  const m = getMedia(name);
  const img = GUIDE_IMAGES[name];
  if (!m || !img) return null;
  return <GuideImg img={img} alt={alt ?? m.alt} eager={eager} sizes={sizes} className={className} />;
};

export default ContentImage;
